import { Component, Input } from "@angular/core";
import { AccountsService } from "../../../services/accounts.service";
import { AnalyticsService } from "../../../services/analytics.service";
import * as moment from "moment";
import { Router } from "@angular/router";

@Component({
  selector: "ngx-team-plan-label",
  templateUrl: "team-plan-label.component.html",
  styleUrls: ["team-plan-label.component.scss"],
})
export class TeamPlanLabelComponent {
  @Input() disableClick: boolean = false;
  @Input() source: string = '';
  @Input() icon: boolean = false;
  constructor(private analyticsService: AnalyticsService,
              private router: Router,
              private accountsService: AccountsService) {
  }

  isTeam: boolean = false;
  ngOnInit() {
    this.isTeam = this.accountsService.isTeam;
  }
  upgradeToTeam() {
    if (this.disableClick) return;
    if (this.isTeam) {
      this.analyticsService.track('team org open help center');
      this.analyticsService.sendHubspotInternalEvent('clicked help', { date:  moment().format('DD/MM/YYYY hh:mm')});
      this.analyticsService.sendHubspotProperty({ clicked_help_date:  moment(new Date()).utc().startOf('day').valueOf() });
      this.router.navigateByUrl('/pages/help');
      return
    }
    document.dispatchEvent(new CustomEvent('open-dialog', { detail: { id: 'upgrade-to-team', source: this.source } }));
  }
}
